import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#2159f6" }, [
      _createElementVNode("path", {
        "data-name": "Vector",
        d: "M10.76 2a.853.853 0 0 0-.86.86v18.28a.86.86 0 0 0 .86.86 9.563 9.563 0 0 0 10-10 9.576 9.576 0 0 0-10-10Z",
        opacity: ".32"
      }),
      _createElementVNode("path", {
        "data-name": "Vector",
        d: "m15.9 11.479-2.84-2.85A.75.75 0 0 0 12 9.689l1.56 1.56H3.99a.75.75 0 0 0 0 1.5h9.57L12 14.319a.754.754 0 0 0 0 1.06.748.748 0 0 0 1.06 0l2.84-2.85a.725.725 0 0 0 0-1.05Z"
      })
    ], -1)
  ]))]))
}
export default { render: render }